<template>
  <div id="result-table">
    <vs-table max-items="30" pagination :data="datas" no-data-text="loading...">
      <template slot="thead">
        <!--<vs-th>No.</vs-th>-->
        <vs-th>งวดวันที่ (Date)</vs-th>
        <vs-th>เริ่มหมุน (Start)</vs-th>
        <vs-th>1ST</vs-th>
        <vs-th>2ND</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <!--<vs-td>
            {{ index+1 }}
          </vs-td>-->
          <vs-td>
            <div class="text-center">
              <h3 class="text-primary">{{ tr.lotto_date }}</h3>
            </div>
          </vs-td>
          <vs-td>
            <div class="text-center">
              {{ startTime(tr.start_spin) }}
            </div>
          </vs-td>
          <vs-td>
            <div class="text-center">
              <h4 class="text-center text-danger">{{tr.results.prize_1st || '-'}}</h4>
              <small class="text-center">{{ startTime(tr.show_1st) }}</small>
            </div>
          </vs-td>
          <vs-td>
            <div class="text-center">
              <h4 class="text-center text-success">{{tr.results.prize_2nd || '-'}}</h4>
              <small>{{ startTime(tr.show_2nd) }}</small>
            </div>
          </vs-td>
          <vs-td>
            <vs-button class="float-right ml-2" color="danger" icon-pack="feather" icon="icon-trash" @click="deleteData(tr.lotto_date)">Delete</vs-button>
            <vs-button class="float-right" color="warning" icon-pack="feather" icon="icon-edit" @click="editData(tr.lotto_date)">Edit</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import LottoService from "@/services/lottoService"

import moment from "moment"

export default {
  data() {
    return {
      results: []
    }
  },
  computed: {
    datas() {
      return this.results
    }
  },
  methods: {
    loadResults() {
      LottoService.getResults().then((response) => {
        this.results = response.datas
      })
    },
    deleteData(id) {
      if (confirm('ต้องการลบ?')) {
        console.log(id)
        LottoService.deleteResult(id).then((response) => {
          if (response.status === 'success') {
            this.loadResults()
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'ลบข้อมูลเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'ลบข้อมูลไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        })
      }
    },
    editData(id) {
      this.$router.push({ name: 'admin-edit-results', params: { resultId: id } })
    },
    startTime(datetime) {
      if (datetime) {
        return moment(datetime).format("YYYY-MM-DD HH:mm")
      } else {
        return '-'
      }
    }
  },
  created() {
    this.loadResults()
  }
}

</script>
<style lang="scss">
#result-table {
  button.vs-button {
    padding: 0.5rem 1rem !important;
  }

  .vs-con-table table {
    width: calc(100% - 10px);
  }

  .vs-table--tbody-table tr:nth-of-type(even) {
    background-color: rgb(255, 255, 204)!important;
    //color: #FFF;
  }

  .vs-table--thead tr {
    background-color: #00308E!important;
    color: #FFF;

    th {
      .vs-table-text {
        justify-content: center;
      }
    }
  }

  .vs-table--tbody-table tr td {
    border:1px solid #00308E;
  }
}

</style>
